import { SLIDE_IN_MENUS } from "../../screens/root/constants";
import { ArtistProfile } from "../../screens/artist/ArtistProfile";
import { AddToMenuWrapper } from "../../screens/reader/components/addToMenu/AddToMenu";
import { AllPagesMenu } from "../../screens/reader/components/allPagesMenu/AllPagesMenu";
import { CommentsMenuWrapper } from "../../screens/reader/components/commentsMenu/CommentsMenu";
import { SettingsMenu } from "../../screens/reader/components/settingsMenu/SettingsMenu";
import { ComicDetails } from "./comicDetails/ComicDetails";
import { ReleaseInfoMenuWrapper } from "./releaseInfo/ReleaseInfoMenu";
import { UserProfile } from "./userProfile/UserProfile";
import { BundleDetailsWrapper } from "./bundleDetails/BundleDetails";

export const menus = {
  [SLIDE_IN_MENUS.settings]: <SettingsMenu />,
  [SLIDE_IN_MENUS.allPages]: <AllPagesMenu />,
  [SLIDE_IN_MENUS.addTo]: <AddToMenuWrapper />,
  [SLIDE_IN_MENUS.comments]: <CommentsMenuWrapper />,
  [SLIDE_IN_MENUS.comicDetails]: <ComicDetails />,
  [SLIDE_IN_MENUS.publisher]: <ArtistProfile />,
  [SLIDE_IN_MENUS.releaseInfo]: <ReleaseInfoMenuWrapper />,
  [SLIDE_IN_MENUS.userProfile]: <UserProfile />,
  [SLIDE_IN_MENUS.bundleDetails]: <BundleDetailsWrapper />,
};
